import React from 'react';
import './About.css';

const stats = [
  { number: '150+', label: 'Projects Completed' },
  { number: '50+', label: 'Happy Clients' },
  { number: '10+', label: 'Years Experience' },
];

const About = () => {
  return (
    <section className="about section" id="about">
      <div className="container">
        <h2 className="section-title">About Us</h2>
        <div className="about-grid">
          <div className="about-text">
            <p>
              Rajmaya Group is a leading construction company committed to
              excellence, innovation, and integrity. With years of experience in
              residential, commercial, and infrastructure development, we have
              earned the trust of our clients by consistently delivering projects
              on time and within budget.
            </p>
            <p>
              Our team of skilled engineers, architects, and project managers
              work together to bring your vision to life — from concept to
              completion.
            </p>
          </div>
          <div className="about-stats">
            {stats.map((stat, index) => (
              <div className="stat" key={index}>
                <h3>{stat.number}</h3>
                <p>{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
